<!-- Responsive Layout Container -->
<div class="illustrations-container">
  <!-- Desktop Table View -->
  <div class="table-wrapper desktop-view">
  <table mat-table [dataSource]="dataSource" matSort class="illustrations-table">
    
    <!-- Contact Date Column -->
    <ng-container matColumnDef="contactDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="contactDate">Kapcs.felv. ideje</th>
      <td mat-cell *matCellDef="let element" 
          [attr.rowspan]="element.isFirstRowForIllustration ? element.areasCount : null"
          [style.display]="element.isFirstRowForIllustration ? 'table-cell' : 'none'">
        <div class="date-cell">
          {{element.contactDate | date:'yyyy.MM.dd'}}
        </div>
      </td>
    </ng-container>

    <!-- Send Date Column -->
    <ng-container matColumnDef="sendDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="sendDate">Kiküldés napja</th>
      <td mat-cell *matCellDef="let element"
          [attr.rowspan]="element.isFirstRowForIllustration ? element.areasCount : null"
          [style.display]="element.isFirstRowForIllustration ? 'table-cell' : 'none'">
        <div class="date-cell">
          {{element.sendDate | date:'yyyy.MM.dd'}}
        </div>
      </td>
    </ng-container>

    <!-- KÜM Column -->
    <ng-container matColumnDef="kum">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="kum">KÜM</th>
      <td mat-cell *matCellDef="let element"
          [attr.rowspan]="element.isFirstRowForIllustration ? element.areasCount : null"
          [style.display]="element.isFirstRowForIllustration ? 'table-cell' : 'none'">
        <div class="kum-cell">
          <app-call-center-chip 
            *ngIf="element.kum" 
            [config]="getUserChip(element.kum)">
          </app-call-center-chip>
        </div>
      </td>
    </ng-container>

    <!-- Company Info Column (Cégnév + Adószám) -->
    <ng-container matColumnDef="companyInfo">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="companyName">Cég neve</th>
      <td mat-cell *matCellDef="let element"
          [attr.rowspan]="element.isFirstRowForIllustration ? element.areasCount : null"
          [style.display]="element.isFirstRowForIllustration ? 'table-cell' : 'none'">
        <div class="company-info-cell">
          <div class="company-name">
            <mat-icon class="company-icon">business</mat-icon>
            <strong>{{element.companyName}}</strong>
          </div>
          <div class="tax-number">
            <mat-icon class="tax-icon">assignment_ind</mat-icon>
            {{element.taxNumber}}
          </div>
        </div>
      </td>
    </ng-container>

    <!-- Customer Info Column (Ügyfél neve + Születési ideje) -->
    <ng-container matColumnDef="customerInfo">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="customerName">Ügyfél információk</th>
      <td mat-cell *matCellDef="let element">
        <div class="customer-info-cell">
          <!-- Normál ügyfelek ezen területhez -->
          <div *ngIf="element.customers && element.customers.length > 0" class="area-customer-list">
            <div *ngFor="let customer of element.customers" class="customer-row">
              <mat-icon class="person-icon">person</mat-icon>
              <strong>{{customer.fullname}}</strong>
              <span *ngIf="customer.birthdate" class="birth-info">
                ({{customer.birthdate | date:'yyyy.MM.dd'}}, {{calculateAge(customer.birthdate)}} év)
              </span>
            </div>
          </div>
          
          <!-- Egyéb entitások ezen területhez -->
          <div *ngIf="element.otherEntities && element.otherEntities.length > 0" class="area-entities-list">
            <div *ngFor="let entity of element.otherEntities" class="entity-row">
              <mat-icon class="person-add-icon">person_add</mat-icon>
              <strong>{{entity.name}}</strong>
              <span *ngIf="entity.birthdate" class="birth-info">
                ({{entity.birthdate | date:'yyyy.MM.dd'}}, {{calculateAge(entity.birthdate)}} év)
              </span>
            </div>
          </div>
          
          <!-- Ha nincs ügyfél ehhez a területhez -->
          <div *ngIf="(!element.customers || element.customers.length === 0) && (!element.otherEntities || element.otherEntities.length === 0)" class="no-customers">
            <span class="no-customers-text">Nincs ügyfél</span>
          </div>
        </div>
      </td>
    </ng-container>

    <!-- Ownership Column -->
    <ng-container matColumnDef="ownership">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="ownership">Tulajdon- rész [%]</th>
      <td mat-cell *matCellDef="let element">
        <div class="ownership-cell">
          <!-- Üres cella -->
        </div>
      </td>
    </ng-container>

    <!-- Area Column -->
    <ng-container matColumnDef="area">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="area">Terület</th>
      <td mat-cell *matCellDef="let element">
        <div class="area-cell">
          <div class="area-header">
            <strong>{{element.area}}</strong>
          </div>
        </div>
      </td>
    </ng-container>

    <!-- Main Persons Column -->
    <ng-container matColumnDef="mainPersons">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="mainPersons">Fő</th>
      <td mat-cell *matCellDef="let element">
        <div class="persons-cell">
          <div class="area-persons-count">
            <mat-icon class="people-icon">people</mat-icon>
            <span class="count">{{element.mainPersons}}</span>
          </div>
        </div>
      </td>
    </ng-container>

    <!-- Fee Column -->
    <ng-container matColumnDef="fee">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="fee">Díj</th>
      <td mat-cell *matCellDef="let element">
        <div class="fee-cell">
          <!-- Díjak ezen területhez -->
          <div *ngIf="element.fees && element.fees.length > 0; else noFees" class="area-fee-list">
            <div *ngFor="let fee of element.fees" class="fee-item">
              <span *ngIf="formatCurrency(fee) as feeInfo" 
                    [class]="'fee-amount fee-' + feeInfo.currency.toLowerCase()">
                {{feeInfo.amount}} {{feeInfo.symbol}}
              </span>
            </div>
          </div>
          
          <ng-template #noFees>
            <span class="no-fee">-</span>
          </ng-template>
        </div>
      </td>
    </ng-container>

    <!-- Notes Column -->
    <ng-container matColumnDef="notes">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="notes">Megjegyzés</th>
      <td mat-cell *matCellDef="let element">
        <div class="notes-cell">
          <span>{{element.notes}}</span>
        </div>
      </td>
    </ng-container>

    <!-- Contact Info Column (E-mail + Telefonszám) -->
    <!-- Contact Info Column (Email + Phone) -->
    <ng-container matColumnDef="contactInfo">
      <th mat-header-cell *matHeaderCellDef>Elérhetőségek</th>
      <td mat-cell *matCellDef="let element"
          [attr.rowspan]="element.isFirstRowForIllustration ? element.areasCount : null"
          [style.display]="element.isFirstRowForIllustration ? 'table-cell' : 'none'">
        <div class="contact-info-cell">
          <!-- Email -->
          <div class="contact-item" *ngIf="element.email">
            <mat-icon class="contact-icon">email</mat-icon>
            <span class="contact-value">{{element.email}}</span>
          </div>
          
          <!-- Phone -->
          <div class="contact-item" *ngIf="element.phone">
            <mat-icon class="contact-icon">phone</mat-icon>
            <span class="contact-value">{{element.phone}}</span>
          </div>
          
          <!-- Fallback if no contacts -->
          <div class="no-contact" *ngIf="!element.email && !element.phone">
            <mat-icon class="no-contact-icon">contact_phone</mat-icon>
            <span class="no-contact-text">Nincs elérhetőség</span>
          </div>
        </div>
      </td>
    </ng-container>

    <!-- Status Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Státusz</th>
      <td mat-cell *matCellDef="let element"
          [attr.rowspan]="element.isFirstRowForIllustration ? element.areasCount : null"
          [style.display]="element.isFirstRowForIllustration ? 'table-cell' : 'none'">
        <div class="status-cell">
          <button
            mat-icon-button
            class="status-button"
            [class.schedule-status]="element.status === 'Kiküldésre vár'"
            [class.sent-status]="element.status === 'Kiküldve'"
            [class.error-status]="element.status === 'Hiba'"
            [title]="element.status"
            [matMenuTriggerFor]="statusMenuRef"
            (click)="onStatusIconClick(element, $event)">
            <mat-icon class="status-icon">
              {{ 
                element.status === 'Kiküldve' ? 'check' : 
                element.status === 'Hiba' ? 'error' : 
                'schedule' 
              }}
            </mat-icon>
          </button>
          
          <!-- Status Menu -->
          <app-small-icon-menu
            #statusMenuComp
            menuId="statusMenu"
            [actions]="statusMenuActions"
            (actionClicked)="onStatusActionClicked($event, element)">
          </app-small-icon-menu>
          
          <!-- Hidden menu reference for trigger -->
          <mat-menu #statusMenuRef="matMenu">
            <button 
              mat-menu-item 
              *ngFor="let action of statusMenuActions" 
              [class]="'action-' + action.action"
              (click)="onStatusActionClicked(action, element)">
              <mat-icon>{{ action.icon }}</mat-icon>
              <span>{{ action.label }}</span>
            </button>
          </mat-menu>
        </div>
      </td>
    </ng-container>    <!-- Table Header and Rows -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>

<!-- Mobile Card View -->
<div class="mobile-view">
  <div class="mobile-card" *ngFor="let illustration of groupedIllustrations; trackBy: trackByElement">
    <div class="card-header">
      <div class="card-title">
        <mat-icon class="company-icon">business</mat-icon>
        <strong>{{illustration.companyName}}</strong>
      </div>
      <div class="status-section">
        <button
          mat-icon-button
          class="status-button"
          [class.schedule-status]="illustration.status === 'Kiküldésre vár'"
          [class.sent-status]="illustration.status === 'Kiküldve'"
          [class.error-status]="illustration.status === 'Hiba'"
          [title]="illustration.status"
          [matMenuTriggerFor]="statusMenuRef"
          (click)="onStatusIconClick(illustration, $event)">
          <mat-icon class="status-icon">
            {{ 
              illustration.status === 'Kiküldve' ? 'check' : 
              illustration.status === 'Hiba' ? 'error' : 
              'schedule' 
            }}
          </mat-icon>
        </button>
      </div>
    </div>

        <div class="card-content">
      <!-- Dates and KÜM Section (side by side) -->
      <div class="card-section dates-kum-section">
        <div class="dates-part">
          <div class="section-label">Dátumok</div>
          <div class="dates-info">
            <div class="date-item">
              <mat-icon>event</mat-icon>
              <span class="date-label">Kapcsolatfelvétel:</span>
              <span class="date-value">{{illustration.contactDate | date:'yyyy.MM.dd'}}</span>
            </div>
            <div class="date-item">
              <mat-icon>send</mat-icon>
              <span class="date-label">Kiküldés:</span>
              <span class="date-value">{{illustration.sendDate | date:'yyyy.MM.dd'}}</span>
            </div>
          </div>
        </div>
        
        <div class="kum-part" *ngIf="illustration.kum">
          <div class="section-label">KÜM</div>
          <div class="kum-info">
            <app-call-center-chip 
              [config]="getUserChip(illustration.kum)">
            </app-call-center-chip>
          </div>
        </div>
      </div>

      <!-- Company Info Section -->
            <!-- Company Info Section -->
      <div class="card-section">
        <div class="section-label">Céginformációk</div>
        <div class="company-details">
          <div class="company-name">
            <mat-icon class="company-icon">business</mat-icon>
            <strong>{{illustration.companyName}}</strong>
          </div>
          <div class="tax-number">
            <mat-icon class="tax-icon">assignment_ind</mat-icon>
            {{illustration.taxNumber}}
          </div>
        </div>
      </div>

      <!-- Areas and Customer Info Section -->
      <div class="card-section">
        <div class="section-label">Területek és Ügyfelek</div>
        <div class="areas-info">
          <!-- Loop through each area for this illustration -->
          <div class="area-item" *ngFor="let areaData of illustration.areas; trackBy: trackByAreaData">
            <div class="area-header">
              <strong>{{areaData.area}}</strong>
              <div class="persons-count">
                <mat-icon class="people-icon">people</mat-icon>
                <span>{{areaData.mainPersons}} fő</span>
              </div>
            </div>
            
            <!-- Customer Information for this area -->
            <div class="customer-list">
              <!-- Normál ügyfelek -->
              <div *ngIf="areaData.customers && areaData.customers.length > 0" class="area-customer-list">
                <div *ngFor="let customer of areaData.customers" class="customer-row">
                  <mat-icon class="person-icon">person</mat-icon>
                  <strong>{{customer.fullname}}</strong>
                  <span *ngIf="customer.birthdate" class="birth-info">
                    ({{customer.birthdate | date:'yyyy.MM.dd'}}, {{calculateAge(customer.birthdate)}} év)
                  </span>
                </div>
              </div>
              
              <!-- Egyéb entitások -->
              <div *ngIf="areaData.otherEntities && areaData.otherEntities.length > 0" class="area-entities-list">
                <div *ngFor="let entity of areaData.otherEntities" class="entity-row">
                  <mat-icon class="person-add-icon">person_add</mat-icon>
                  <strong>{{entity.name}}</strong>
                  <span *ngIf="entity.birthdate" class="birth-info">
                    ({{entity.birthdate | date:'yyyy.MM.dd'}}, {{calculateAge(entity.birthdate)}} év)
                  </span>
                </div>
              </div>
              
              <!-- Ha nincs ügyfél ehhez a területhez -->
              <div *ngIf="(!areaData.customers || areaData.customers.length === 0) && (!areaData.otherEntities || areaData.otherEntities.length === 0)" class="no-customers">
                <span class="no-customers-text">Nincs ügyfél</span>
              </div>
            </div>

            <!-- Fee for this area -->
            <div class="area-fee">
              <div class="fee-label">Díj:</div>
              <div *ngIf="areaData.fees && areaData.fees.length > 0; else noFees" class="area-fee-list">
                <div *ngFor="let fee of areaData.fees" class="fee-item">
                  <span *ngIf="formatCurrency(fee) as feeInfo" 
                        [class]="'fee-amount fee-' + feeInfo.currency.toLowerCase()">
                    {{feeInfo.amount}} {{feeInfo.symbol}}
                  </span>
                </div>
              </div>
              <ng-template #noFees>
                <span class="no-fee">-</span>
              </ng-template>
            </div>

            <!-- Notes for this area -->
            <div class="area-notes" *ngIf="areaData.notes">
              <div class="notes-label">Megjegyzés:</div>
              <div class="notes-content">
                <span>{{areaData.notes}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Contact Information Section -->
            <!-- Contact Information Section -->
      <div class="card-section">
        <div class="section-label">Elérhetőségek</div>
        <div class="contact-details">
          <div class="contact-item" *ngIf="illustration.email">
            <mat-icon class="contact-icon">email</mat-icon>
            <span class="contact-value">{{illustration.email}}</span>
          </div>
          <div class="contact-item" *ngIf="illustration.phone">
            <mat-icon class="contact-icon">phone</mat-icon>
            <span class="contact-value">{{illustration.phone}}</span>
          </div>
          <div class="no-contact" *ngIf="!illustration.email && !illustration.phone">
            <mat-icon class="no-contact-icon">contact_phone</mat-icon>
            <span class="no-contact-text">Nincs elérhetőség</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Status Menu (hidden, referenced by button) -->
    <mat-menu #statusMenuRef="matMenu">
      <button 
        mat-menu-item 
        *ngFor="let action of statusMenuActions" 
        [class]="'action-' + action.action"
        (click)="onStatusActionClicked(action, illustration)">
        <mat-icon>{{ action.icon }}</mat-icon>
        <span>{{ action.label }}</span>
      </button>
    </mat-menu>
  </div>
</div>

<!-- Paginator -->
<mat-paginator 
  [length]="totalIllustrations"
  [pageSize]="pageSize"
  [pageIndex]="currentPage"
  [pageSizeOptions]="[10, 25, 50, 100]" 
  (page)="onPageChange($event)"
  showFirstLastButtons
  aria-label="Válassza ki az oldalt az illusztrációk száma alapján">
</mat-paginator>

</div> <!-- Close illustrations-container -->